import React, { useEffect, useState} from "react";

import GlipWalletGlobal from '../../services/walletService';


import WalletHeadComponent from './WalletHeadComponent';
import WalletApproveComponent from './WalletApproveComponent';
import TransactionInformationComponent from '../TransactionInformationComponents/TransactionInformationComponent';
import Loader from "../Loader";
import styles from "../../styles/Home.module.css";


const UserWalletConfirmationPage = (props:any) => {
    
    const [width, setWidth] = useState<number>(window.innerWidth);
    const [transactionDetails, setTransactionDetails] = useState<any>(null);
    const [messageDetails, setMessageDetails] = useState<any>(null);
    const [fiatCurrency, setFiatCurrency] = useState('usd');
    
    const handleApproveClick = async () => {
        if(messageDetails){
            (await GlipWalletGlobal.getMessageSigningService()).approveMessageSign();
            return;
        }
        (await GlipWalletGlobal.getTransactionService()).approveTransaction();
    }

    const handleDeclineClick = async () => {
        if(messageDetails){
            (await GlipWalletGlobal.getMessageSigningService()).declineMessageSign();
            return;
        }
        (await GlipWalletGlobal.getTransactionService()).declineTransaction();
    }
    
    useEffect(()=>{
        (async () => {
            await GlipWalletGlobal.initFromURL();
            const params:any = new Proxy(new URLSearchParams(
            window.location.search), {
                get: (searchParams:any, prop:any) => searchParams.get(prop),
            });
            if(params.signMessage || params.signPersonalMessage){
                let newMessageDetails = await (await GlipWalletGlobal.getMessageSigningService()).parseAndSetMessageFromURI();
                setMessageDetails(newMessageDetails);
            }
            else{
                let newTransactionDetails = await (await GlipWalletGlobal.getTransactionService()).parseAndSetTransactionFromURI(fiatCurrency);
                setTransactionDetails(newTransactionDetails);
            }
        })();
    },[]);
        
    function handleWindowSizeChange() {
        setWidth(window.innerWidth);
    }
    
    useEffect(() => {
        window.addEventListener('resize', handleWindowSizeChange);
        handleWindowSizeChange();
        return () => {
            window.removeEventListener('resize', handleWindowSizeChange);
        }
    }, []);

    const isMobile = width <= 768;
    
    
    if(!transactionDetails && !messageDetails){
        return (
            <div className={styles.centerFlex}><Loader /></div>
        );
    }
    
    return (
        <div style={{display:'flex', flexDirection:'column',  backgroundColor:'#0F0F0F', height:'100%'}}>
          <WalletHeadComponent isMobile={isMobile}></WalletHeadComponent>
          {transactionDetails && (
              <>
                <TransactionInformationComponent
                    transactionDetails={transactionDetails}
                    isMobile={isMobile}></TransactionInformationComponent>
                <WalletApproveComponent
                    handleDeclineClick={handleDeclineClick}
                    handleApproveClick={handleApproveClick}
                    transactionDetails={transactionDetails}
                    isMobile={isMobile}>
                </WalletApproveComponent>
              </>
          )}
          {messageDetails && (<>
            <div style={{display:'flex',
                         flexDirection:'column',
                         alignItems:'center',
                         justifyContent:'center',
                         width: '100vw',
                         paddingTop:'20px'}}>
              <div style={{color:'white', fontSize:'20px', fontWeight:'bold', marginBottom:'30px'}}>Signing Message </div>
              <p style={{color:'white',
                         fontSize:'14px',
                         fontWeight:'bold',
                         boxSizing: 'border-box',
                         maxWidth: '90%',
                         wordWrap: 'break-word',
                         paddingLeft: 10,
                         paddingRight: 10}}>
                {messageDetails.split('\n').map((line:any, index:any) => {
                    return <span key={index}>{line}<br/></span>
                })}
              </p>
            </div>
            <WalletApproveComponent
                handleDeclineClick={handleDeclineClick}
                handleApproveClick={handleApproveClick}
                transactionDetails={messageDetails}
                isMobile={isMobile}>
            </WalletApproveComponent>
          </>)}
        </div>
    );
}

export default UserWalletConfirmationPage;
